var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftanglearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3254 2.95388C10.1157 2.77417 9.80007 2.79845 9.62036 3.00811L5.62036 7.67478C5.45987 7.86202 5.45987 8.13832 5.62036 8.32557L9.62036 12.9922C9.80007 13.2019 10.1157 13.2262 10.3254 13.0465C10.535 12.8668 10.5593 12.5511 10.3796 12.3414L6.65853 8.00017L10.3796 3.6589C10.5593 3.44924 10.535 3.13359 10.3254 2.95388Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftanglearrow);
export default __webpack_public_path__ + "static/media/leftanglearrow.77a61fa3ec8427035cf9babb935757e9.svg";
export { ForwardRef as ReactComponent };